import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getRegularInfo } from '@/api/org/per';
import { saveNoticeConfig } from 'api/dashboard';
import organization from '@/components/organization';
import { contentTemplate, initData, ruleInitData } from './config.js';
export default {
  components: {
    organization: organization
  },
  data: function data() {
    return {
      visible: false,
      contentTemplate: contentTemplate,
      initData: JSON.parse(JSON.stringify(initData)),
      ruleInitData: ruleInitData,
      regularInfo: {},
      staffMax: 100,
      orgVisible: false
    };
  },
  methods: {
    init: function init(row) {
      this.visible = true;
      this.regularInfoFn(); // 试用期管理枚举项
      if (row) this.initData = JSON.parse(JSON.stringify(row));
      this.$nextTick(function () {});
    },
    regularInfoFn: function regularInfoFn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getRegularInfo();
            case 2:
              res = _context.sent;
              // 试用期管理枚举项
              if (res && res.code === 1) _this.regularInfo = res.data;
              _this.initData.notice_time.forEach(function (item) {
                _this.$set(item, 'notice_date', _this.regularInfo.notice_date);
                _this.$set(item, 'notice_date_type', _this.regularInfo.notice_date_type);
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.initData = JSON.parse(JSON.stringify(initData));
      this.$refs.initData.resetFields();
    },
    handleChangeColumn: function handleChangeColumn(item) {
      item.type = '';
    },
    delRemindData: function delRemindData(index) {
      this.initData.notice_time.splice(index, 1);
    },
    addRemindData: function addRemindData() {
      // 添加提醒时间
      if (this.initData.notice_time.length === 5) return;
      this.initData.notice_time.push({
        column: '',
        // 提醒时间：转正日期、入职日期
        type: '',
        // 提醒时间：之前、之后
        day: '',
        // 提醒时间： XX天
        notice_date: this.regularInfo.notice_date,
        notice_date_type: this.regularInfo.notice_date_type
      });
    },
    openOrg: function openOrg() {
      // 打开选择人员弹窗
      this.orgVisible = true;
    },
    getSelectNode: function getSelectNode(data) {
      // 选择人员
      this.initData.staff_ids = data.staff_list;
    },
    closeStaff: function closeStaff(index) {
      // 删除选择人员
      this.initData.staff_ids.splice(index, 1);
    },
    handleContent: function handleContent(type, name) {
      // 点击变量
      this.initData.content += "#".concat(name, "#\uFF0C");
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;
      this.$refs.initData.validate(function (valid) {
        if (valid) {
          _this2.initData.staff_ids = _this2.initData.staff_ids.map(function (item) {
            return item.staff_id;
          });
          saveNoticeConfig(_this2.initData).then(function (res) {
            if (res && res.code === 1) {
              _this2.$emit('noticeConfig');
              _this2.$message.success(res.message);
              _this2.handleClose();
            }
          });
        }
      });
    }
  }
};